.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  background: var(--tuna-surface-elevated);
}

.guess {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.empty {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.lane {
  position: relative;
  height: 2.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.chord {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  box-sizing: border-box;
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

/* §4.2: a guessed timing is drawn dashed; the line above the lane and each name say so too (WCAG 1.4.1) */
.lane[data-confirmed='false'] .chord {
  border-style: dashed;
}

.name {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 0 var(--tuna-spacing-1);
  overflow: hidden;
  border: 0;
  background: transparent;
  color: var(--tuna-content-primary);
  font: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* The long-press offer replaces the browser's own touch menu */
  -webkit-touch-callout: none;
  user-select: none;
}

/*
 * The end edge sits ON the boundary, half over the next chord, so the chord's name keeps the chord's whole
 * width (Joni, M1–M5 review). The last chord's edge stays inside the lane.
 */
.edge {
  position: absolute;
  top: 0;
  bottom: 0;
  right: -6px;
  z-index: 1;
  width: 12px;
  cursor: ew-resize;
  touch-action: none;
}

.edge::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  border-left: 1px solid var(--tuna-border-default);
}

.lastEdge {
  right: 0;
}

.name:focus-visible,
.edge:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

/* §9: touch targets of 44px, the edge handle included */
@media (pointer: coarse) {
  /* 44px inside the chord's 1px border, top and bottom */
  .lane {
    height: calc(44px + 2px);
  }

  .edge {
    right: -22px;
    width: 44px;
  }

  .lastEdge {
    right: 0;
  }
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

/* Add chords on the sketch (melody toolkit M9.2): the field, its button, and the line under them */
.addChords {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.problem {
  flex-basis: 100%;
  margin: 0;
  color: var(--tuna-content-secondary);
}
